import styled from "styled-components";
import colours from "../../lib/colours";
import appConfig from "../../lib/appConfig";

const Container = styled.div`
  height: 100%;
  width: ${appConfig.dataPanelWidth}px;
  background-color: ${colours.white};
  @media (max-width: ${appConfig.tabletWidth}px) {
    width: calc(100vw - ${appConfig.leftNavWidth + 1}px);
    height: 55vh;
  }
`;

interface IProps {
  children: any;
}

function DataPanel({ children }: IProps) {
  return <Container>{children}</Container>;
}

export default DataPanel;
